import * as React from "react";
import Box from "@mui/material/Box";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import TableSortLabel from "@mui/material/TableSortLabel";
import Typography from "@mui/material/Typography";
import Paper from "@mui/material/Paper";
import { visuallyHidden } from "@mui/utils";
import { Header } from "Components/Header";
import { LocalImage } from "Utils/images";
import { Colors } from "Utils/colors";
import {
  Button,
  Grid,
  Stack,
  Dialog,
  DialogContent,
  DialogTitle,
  CircularProgress,
  Modal,
  Menu,
} from "@mui/material";
import ArrowDropDownOutlinedIcon from "@mui/icons-material/ArrowDropDownOutlined";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import { MenuItem, Select } from "@mui/material";
import { useContext, useEffect, useState } from "react";
import { isValidString, todaySameAsGivenDate } from "Utils/validators";
import { SnackBarContext } from "Context/SnackContext";
import AddCustomer from "./AddCustomer";
import Tooltip from "@mui/material/Tooltip";
import IconButton from "@mui/material/IconButton";
import CancelIcon from "@mui/icons-material/Cancel";
import { useAppDispatch, useAppSelector } from "Hooks/reduxHook";
import { RootState } from "Features/store";
import {
  getAccessToken,
  getAllCustomersCount,
  listCustomer,
} from "Features/slice/customer/customer.Slice";
import { CustomerListModel } from "Features/slice/customer/customer.model";
import { formatAsUsPhoneNo } from "Utils/transform";
import { CreateCustomerInitialValues } from "Model/Customer.model";
import { Customer } from "Features/services/customer.api";
import { EditClientInformation } from "Screens/Invoice/EditClientInformation";
import CloseIcon from "@mui/icons-material/Close";
import { ClientInformation } from "./ClientInformation";

interface Data {
  customerId: string;
  customerName: string;
  email: string;
  phone: string;
  credit_line_balance: string;
  balance: string;
  is_active: number;
  created_at: string;
  action: string;
}

function createData(
  customerId: string,
  customerName: string,
  email: string,
  phone: string,
  credit_line_balance: string,
  balance: string,
  is_active: number,
  created_at: string,
  action?: string
): Data {
  return {
    customerId,
    customerName,
    email,
    phone,
    credit_line_balance,
    balance,
    is_active,
    created_at,
    action: action as string,
  };
}

const listRows = [
  createData(
    "ADy171",
    "Maddy",
    "maddy@yahoo.in",
    "4567890123",
    "14/9/22",
    "$10.00",
    1,
    "2023-12-22T18:04:57.000Z"
  ),
  createData(
    "ADy172",
    "Jimmy",
    "jimmy@yahoo.in",
    "5678901234",
    "15/9/22",
    "$25.00",
    1,
    "2023-12-22T18:04:57.000Z"
  ),
  createData(
    "ADy173",
    "Clara",
    "clara@yahoo.in",
    "6789012345",
    "16/9/22",
    "$45.00",

    1,
    "2023-12-22T18:04:57.000Z"
  ),
  createData(
    "ADy174",
    "Davira",
    "davira@yahoo.in",
    "7890123456",
    "11/9/22",
    "$4.00",

    1,
    "2023-12-22T18:04:57.000Z"
  ),
  createData(
    "ADy175",
    "Thomas",
    "thomas@yahoo.in",
    "8901234567",
    "11/9/22",
    "$250.00",

    0,
    "2023-12-22T18:04:57.000Z"
  ),
  createData(
    "ADy184",
    "Antony",
    "anto@yahoo.in",
    "9012345678",
    "11/9/22",
    "$1050.00",

    1,
    "2023-12-22T18:04:57.000Z"
  ),
  createData(
    "ADy177",
    "Samir",
    "samir@yahoo.in",
    "7123456890",
    "11/9/22",
    "$103.00",
    1,
    "2023-12-22T18:04:57.000Z"
  ),
  createData(
    "ADy178",
    "Sam",
    "sam@yahoo.in",
    "612345890",
    "11/9/22",
    "$23.00",
    0,
    "2023-12-22T18:04:57.000Z"
  ),
  createData(
    "ADy179",
    "William",
    "will@yahoo.in",
    "8790123456",
    "11/9/22",
    "$73.00",
    1,
    "2023-12-22T18:04:57.000Z"
  ),
  createData(
    "ADy180",
    "Samir",
    "samir@yahoo.in",
    "9876123409",
    "11/9/22",
    "$65.00",
    1,
    "2024-01-09T05:04:57.000Z"
  ),
  createData(
    "ADy181",
    "Nixen",
    "nixen@yahoo.in",
    "1234567890",
    "11/9/22",
    "$78.00",
    1,
    "2023-12-22T18:04:57.000Z"
  ),
  createData(
    "ADy182",
    "Erica",
    "erica@yahoo.in",
    "2345678901",
    "11/9/22",
    "$90.00",
    1,
    "2024-01-09T18:04:57.000Z"
  ),
  createData(
    "ADy183",
    "Taniska",
    "kanika@yahoo.in",
    "3456789012",
    "11/9/22",
    "$117.00",
    0,
    "2024-01-09T12:04:57.000Z"
  ),
];

function descendingComparator<T>(a: T, b: T, orderBy: keyof T) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

type Order = "asc" | "desc";

function getComparator<Key extends keyof any>(
  order: Order,
  orderBy: Key
): (
  a: { [key in Key]: number | string | boolean },
  b: { [key in Key]: number | string | boolean }
) => number {
  return order === "desc"
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

function stableSort<T>(
  array: readonly T[],
  comparator: (a: T, b: T) => number
) {
  if (array?.length > 0) {
    const stabilizedThis = array?.map(
      (el, index) => [el, index] as [T, number]
    );
    stabilizedThis?.sort((a, b) => {
      const order = comparator(a[0], b[0]);
      if (order !== 0) {
        return order;
      }
      return a[1] - b[1];
    });
    return stabilizedThis?.map((el) => el[0]);
  }
  return [];
}

interface HeadCell {
  disablePadding: boolean;
  id: any; //keyof CustomerListModel extends Action;
  label: string;
  numeric: boolean;
}

const headCells: readonly HeadCell[] = [
  {
    id: "qb_customer_id",
    numeric: false,
    disablePadding: true,
    label: "Customer ID",
  },
  {
    id: "display_name",
    numeric: false,
    disablePadding: false,
    label: "Customer Name",
  },
  {
    id: "email",
    numeric: false,
    disablePadding: false,
    label: "Email",
  },
  {
    id: "phoneNo",
    numeric: false,
    disablePadding: false,
    label: "Phone",
  },
  {
    id: "credit_line_balance",
    numeric: false,
    disablePadding: false,
    label: "Credit Line",
  },
  {
    id: "balance",
    numeric: false,
    disablePadding: false,
    label: "Balance",
  },
  {
    id: "is_active",
    numeric: false,
    disablePadding: false,
    label: "Active",
  },
  {
    id: "action",
    numeric: false,
    disablePadding: false,
    label: "Action",
  },
];

interface EnhancedTableProps {
  onRequestSort: (
    event: React.MouseEvent<unknown>,
    property: keyof CustomerListModel
  ) => void;
  order: Order;
  orderBy: string;
  rowCount: number;
}

function EnhancedTableHead(props: EnhancedTableProps) {
  const { order, orderBy, rowCount, onRequestSort } = props;
  const createSortHandler =
    (property: keyof CustomerListModel) =>
      (event: React.MouseEvent<unknown>) => {
        onRequestSort(event, property);
      };

  return (
    <TableHead sx={{ background: "#007CA40D" }}>
      <TableRow sx={{ borderRight: "none", borderLeft: "none" }}>
        {headCells?.map((headCell) => (
          <TableCell
            sx={{
              background: "#007CA40D",
              borderBottom: "none",
              textAlign: "left",
              borderRight: "none",
              borderLeft: "none",
            }}
            key={headCell.id}
            // align={headCell.numeric ? 'right' : 'left'}
            padding={headCell.disablePadding ? "none" : "normal"}
            sortDirection={orderBy === headCell.id ? order : false}
          >
            <TableSortLabel
              active={orderBy === headCell.id}
              direction={orderBy === headCell.id ? order : "asc"}
              onClick={createSortHandler(headCell.id)}
              sx={{ fontSize: "10px" }}
            >
              {headCell.label}
              {orderBy === headCell.id ? (
                <Box component="span" sx={visuallyHidden}>
                  {order === "desc" ? "sorted descending" : "sorted ascending"}
                </Box>
              ) : null}
            </TableSortLabel>
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}

export default function Customers() {

  const style = {
    position: "absolute" as "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-40%, -50%)",
    bgcolor: "background.paper",
    boxShadow: 24,
    p: 4,
    borderRadius: "12px",
    width: "50%",
    height: "90%",
    overflowX: "hidden",
    overflowY: "auto",
  };

  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedRow, setSelectedRow] = useState(null);

  const handleMenuOpen = (event: any, row: any) => {
    setAnchorEl(event.currentTarget);
    setSelectedRow(row);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const [selectedCustomer, setSelectedCustomer] = useState();
  const [customerId, setCustomerId] = useState();

  const [open, setOpen] = useState(false);

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const { handleSnackbar } = useContext(SnackBarContext);
  const dispatch = useAppDispatch();

  const {
    customersList,
    customerListFetching,
    customerListFetchError,
    access_token,
    customersCount,
  } = useAppSelector((state: RootState) => state.customer);

  const [order, setOrder] = React.useState<Order>("asc");
  const [orderBy, setOrderBy] =
    React.useState<keyof CustomerListModel>("qb_customer_id");
  const [dense, setDense] = React.useState(false);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);
  const [rows, setRows] = useState<CustomerListModel[]>(customersList);
  const [pageNo, setPageNo] = useState(1);
  const [selectedTab, setSelectedTab] = useState<"all" | "new">("all");
  const [loading, setLoading] = useState<boolean>(false);

  const [addCustomer, setAddCustomer] = useState({
    visible: false,
    title: "Add Customer",
  });
  const [form, setForm] = useState(CreateCustomerInitialValues);
  const [offset, setOffset] = useState(0);

  const closeAddCustomerModal = (updateList = false) => {
    setAddCustomer({ visible: false, title: "" });
    setForm(CreateCustomerInitialValues);
    if (updateList) {
      getUsersList(offset, selectedTab);
    }
  };

  const paginationOrder = Math.floor(customersCount / 10) || 0;

  useEffect(() => {
    dispatch(getAccessToken());
  }, []);

  useEffect(() => {
    if (access_token) {
      getUsersList(offset, selectedTab);
      dispatch(getAllCustomersCount(access_token));
    }
  }, [access_token]);

  useEffect(() => {
    onClickTab(selectedTab, false);
    setRows(customersList);
  }, [customersList]);

  const getUsersList = (offset: number, selectedTab: "all" | "new") => {
    const payload = { access_token, offset, tab: selectedTab };
    dispatch(listCustomer(payload));
  };

  const handleRequestSort = (
    event: React.MouseEvent<unknown>,
    property: keyof CustomerListModel
  ) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  const visibleRows = React.useMemo(
    () => stableSort(rows, getComparator(order, orderBy)),
    [rows, order, orderBy, pageNo, rowsPerPage]
  );

  const onClickTab = (tab: "all" | "new", changePageNo = true) => {
    changePageNo && setPageNo(1);
    if (changePageNo) {
      setSelectedTab(tab);
      getUsersList(0, tab);
      dispatch(getAllCustomersCount(access_token));
    } else {
      const filteredList = customersList?.filter((item: CustomerListModel) =>
        tab === "new" ? todaySameAsGivenDate(item.created_at) : item
      );
      setRows(filteredList);
    }
  };

  const changePageNo = (no: number) => {
    setPageNo(no);
    const newOffset = no * 10 + 1;
    setOffset(newOffset);
    getUsersList(newOffset, selectedTab);
  };

  const getCurrentItemsCount = () => {
    if ((pageNo * 10) % visibleRows?.length === 0) {
      if (visibleRows?.length % 10 === 0) {
        return pageNo * 10;
      }
      return customersCount;
    }
    return visibleRows?.length;
  };

  const editCustomer = (item: any) => {
    toggleAddCustomer("Edit Customer");
    const payload = {
      DisplayName: item?.display_name || "",
      company_name: item?.company_name || "",
      customerType: item?.customer_type || "",
      phoneNo: item?.phoneNo || "",
      email: item?.email || "",
      credit_line_balance: item?.credit_line_balance || '0',
      total_credit_line: item?.total_credit_line || '0',
      address: item?.address || "",
      city: item?.city || "",
      state: item?.countrySubDivisionCode || "",
      zip: item?.zip || "",
      country: item?.country || "",
      qb_customer_id: item?.qb_customer_id || "",
      SyncToken: item?.SyncToken || "",
      billingSameAsShipping: item?.billingSameAsShipping === 1 ? true : false,
      shippingName: item?.shipping_Name || "",
      shippingAddress: item?.ShipAddr?.Line1 || "",
      shippingCity: item?.ShipAddr?.City || "",
      shippingState: item?.ShipAddr?.CountrySubDivisionCode || "",
      shippingZip: item?.ShipAddr?.PostalCode || "",
    };
    setForm(payload);
  };

  const removeCustomer = async (row: any) => {
    debugger;
    const payload = {
      access_token,
      Id: row.qb_customer_id,
      displayName: row.display_name,
    };

    try {
      const response = await Customer.instance.deleteCustomer(payload);
      if (response) {
        handleSnackbar(true, "Customer deleted successfully", "success");
        getUsersList(offset, selectedTab);
      } else {
        handleSnackbar(true, "Failed to delete customer. Try again", "error");
      }
    } catch (error) {
      handleSnackbar(true, "Something went wrong. Try again", "error");
    }
  };

  const toggleAddCustomer = (title: string) => {
    setAddCustomer({ visible: true, title });
  };

  const handleSearchCustomer = async (value: string) => {
    const payload = {
      access_token: access_token,
      search_query: value,
      offset,
    };

    try {
      setLoading(true);
      const response = await Customer.instance.searchCustomer(payload);
      const data = response.data.data;
      setRows(data);
      setOffset(0);
    } catch (error: any) {
      handleSnackbar(true, `${error.message}` || "Something went wrong. Try again", "error");
    } finally {
      setLoading(false);
    }
  };

  const handleCustomerSelect = (row: any) => {
    setCustomerId(row.qb_customer_id);
    setSelectedCustomer(row);
    setOpen(true);
  };

  console.log("visibleRow--", visibleRows)

  return (
    <Box
      component="main"
      sx={{
        backgroundImage: `url(${LocalImage.contactBg})`,
        backgroundRepeat: "no-repeat",
        backgroundColor: `${Colors.white}`,
        backgroundSize: "20% auto",
        backgroundPosition: "right bottom",
        flex: 1,
        overflow: "hidden",
        pl: 3,
        pr: 2,
        pt: 15,
        pb: 8,
      }}
    >
      <Header
        title={"Customer Overview"}
        subTitle="You doing good, Keep it up!"
        btnName="New Customer"
        onInputChange={handleSearchCustomer}
        onButtonClick={() => toggleAddCustomer("Add Customer")}
      />

      {isValidString(customerListFetchError) ? (
        <Typography>{customerListFetchError}</Typography>
      ) : (
        <Grid container>
          <Grid item sm={12} lg={12}>
            <Box sx={{ width: "100%" }} className="table-top-border">
              <Grid container sx={{ pb: 1 }}>
                <Grid item sm={12}>
                  <Stack spacing={2} direction="row">
                    <Button
                      variant="outlined"
                      className={`button-style01 ${selectedTab === "all" ? "button-style01-active" : ""
                        }`}
                      onClick={() => onClickTab("all")}
                    >
                      All Customers
                    </Button>
                    <Button
                      variant="outlined"
                      className={`button-style01 ${selectedTab === "new" ? "button-style01-active" : ""
                        }`}
                      onClick={() => onClickTab("new")}
                    >
                      New Clients
                    </Button>
                  </Stack>
                </Grid>
              </Grid>
            </Box>

            <Box sx={{ width: "100%" }}>
              <Paper sx={{ width: "100%", mb: 2, boxShadow: "none" }}>
                <TableContainer sx={{ maxHeight: 500 }}>
                  <Table
                    sx={{ minWidth: 750 }}
                    aria-labelledby="tableTitle"
                    size={dense ? "small" : "medium"}
                  >
                    <EnhancedTableHead
                      order={order}
                      orderBy={orderBy}
                      onRequestSort={handleRequestSort}
                      rowCount={rows?.length || 0}
                    />

                    <TableBody>
                      {loading ? (
                        <TableRow>
                          <TableCell colSpan={8} align="center">
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                fontWeight: "bolder",
                                height: "70vh",
                              }}
                            >
                              <CircularProgress />
                            </div>
                          </TableCell>
                        </TableRow>
                      ) : (
                        <>
                          {visibleRows?.length > 0 ? (
                            visibleRows.map((row, index) => {
                              const labelId = `enhanced-table-checkbox-${index}`;
                              return (
                                <TableRow
                                  hover
                                  role="checkbox"
                                  tabIndex={-1}
                                  key={row.qb_customer_id}
                                  sx={{ cursor: "pointer" }}
                                >
                                  <TableCell
                                    component="th"
                                    id={labelId}
                                    scope="row"
                                    padding="none"
                                    align="left"
                                    sx={{
                                      fontSize: "12px",
                                      textAlign: "center",
                                      pr: 3,
                                    }}
                                  >
                                    {row?.qb_customer_id}
                                  </TableCell>
                                  <TableCell
                                    sx={{
                                      fontSize: "12px",
                                      cursor: "pointer",
                                      "&:hover": { color: "#007ca4" },
                                    }}
                                    align="left"
                                    onClick={() => handleCustomerSelect(row)}
                                  >
                                    {row?.display_name || "NA"}
                                  </TableCell>
                                  <TableCell
                                    sx={{ fontSize: "12px" }}
                                    align="left"
                                  >
                                    {row.email}
                                  </TableCell>
                                  <TableCell
                                    sx={{ fontSize: "12px" }}
                                    align="left"
                                  >
                                    {row.phoneNo || "-"}
                                  </TableCell>
                                  <TableCell
                                    sx={{
                                      fontSize: "12px",
                                      textAlign: "center",
                                      pr: 3,
                                    }}
                                    align="left"
                                  >
                                    {row?.credit_line_balance || 0}
                                  </TableCell>
                                  <TableCell
                                    sx={{
                                      fontSize: "12px",
                                      textAlign: "center",
                                      pr: 3,
                                    }}
                                    align="left"
                                  >
                                    {row?.balance.toFixed(2) || 0}
                                  </TableCell>
                                  <TableCell
                                    sx={{ fontSize: "12px" }}
                                    align="left"
                                  >
                                    {row.is_active == 1
                                      ? "Active"
                                      : "In Active"}
                                  </TableCell>
                                  <TableCell
                                    align="left"
                                    sx={{
                                      color: "#29AA6D",
                                      fontSize: "12px",
                                      cursor: "pointer",
                                    }}
                                    onClick={(event) =>
                                      handleMenuOpen(event, row)
                                    }
                                  >
                                    edit
                                    <ArrowDropDownOutlinedIcon
                                      sx={{ position: "relative", top: 7 }}
                                    />
                                  </TableCell>
                                </TableRow>
                              );
                            })
                          ) : (
                            <TableRow>
                              <TableCell colSpan={8} align="center">
                                <p>No Data Found</p>
                              </TableCell>
                            </TableRow>
                          )}

                          {/* Menu for Edit and Delete */}
                          <Menu
                            anchorEl={anchorEl}
                            open={Boolean(anchorEl)}
                            onClose={handleMenuClose}
                          >
                            <MenuItem
                              onClick={() => {
                                handleCustomerSelect(selectedRow);
                                handleMenuClose();
                                
                              }}
                            >
                              Edit Client
                            </MenuItem>
                            <MenuItem
                              onClick={() => {
                                removeCustomer(selectedRow);
                                handleMenuClose();
                              }}
                            >
                              Remove
                            </MenuItem>
                          </Menu>
                        </>
                      )}
                    </TableBody>
                  </Table>
                </TableContainer>

                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "space-between",
                    alignItems: "flex-start",
                    mt: 3,
                  }}
                >
                  <Typography
                    variant="body1"
                    component={"body"}
                    color={"#717579"}
                    fontSize={"12px"}
                  >
                    Showing {getCurrentItemsCount()} from {customersCount || 0}{" "}
                    entries
                  </Typography>

                  {paginationOrder > 0 ? (
                    <Box sx={{ display: "flex", flexDirection: "row" }}>
                      <Box
                        onClick={() => {
                          if (pageNo > 1) {
                            changePageNo(pageNo - 1);
                          }
                        }}
                        sx={{
                          backgroundColor: "#007CA4",
                          padding: "8px 8px 0px 8px",
                          color: "#fff",
                          borderTopLeftRadius: "6px",
                          borderBottomLeftRadius: "6px",
                        }}
                      >
                        <ArrowBackIosIcon
                          sx={{ fontSize: "14px", mt: "2px" }}
                        />
                      </Box>
                      <Select
                        labelId="demo-select-small-label"
                        id="demo-select-small"
                        value={pageNo}
                        inputProps={{
                          "aria-label": "Without label",
                          sx: { padding: "6px 20px !important" },
                        }}
                        onChange={(event) => {
                          changePageNo(event.target.value as number);
                        }}
                        fullWidth
                        size="small"
                        placeholder="1"
                        IconComponent={() => null}
                      >
                        {new Array(paginationOrder)
                          .fill(paginationOrder)
                          ?.map((item, index) => (
                            <MenuItem value={index + 1} key={index}>
                              {index + 1}
                            </MenuItem>
                          ))}
                      </Select>
                      <Box
                        onClick={() => {
                          if (pageNo < paginationOrder) {
                            changePageNo(pageNo + 1);
                          }
                        }}
                        sx={{
                          backgroundColor: "#007CA4",
                          padding: "8px 8px 0px 8px",
                          color: "#fff",
                          borderTopRightRadius: "6px",
                          borderBottomRightRadius: "6px",
                        }}
                      >
                        <ArrowForwardIosIcon
                          sx={{ fontSize: "14px", mt: "2px" }}
                        />
                      </Box>
                    </Box>
                  ) : null}
                </Box>
              </Paper>
            </Box>
          </Grid>
        </Grid>
      )}

      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <>
          <Box sx={style}>
            <ClientInformation
              selectedCustomer={selectedCustomer}
              customerId={customerId}
              closeModal={handleClose}
            />
          </Box>

          <Button
            sx={{
              backgroundColor: "#FFAA2A",
              padding: "8px 0px",
              float: "right",
              right: "18%",
              top: "2.5%",
              "&:hover": {
                backgroundColor: "#E69927",
              },
            }}
            onClick={handleClose}
          >
            <CloseIcon sx={{ fontSize: "32px", color: "#fff" }} />
          </Button>
        </>
      </Modal>

      <Dialog open={customerListFetching}>
        <DialogContent>
          <CircularProgress />
        </DialogContent>
      </Dialog>

      <Dialog open={addCustomer.visible}>
        <Grid sx={{ mb: -2 }} container spacing={2} alignItems={"center"}>
          <Grid item md={11}>
            <Box display="flex" justifyContent="space-between">
              <DialogTitle>{addCustomer.title}</DialogTitle>
            </Box>
          </Grid>
          <Grid item md={1}>
            <Tooltip title="Cancel" style={{ marginRight: 8, float: "right" }}>
              <IconButton onClick={() => closeAddCustomerModal(false)}>
                <CancelIcon />
              </IconButton>
            </Tooltip>
          </Grid>
        </Grid>

        <DialogContent sx={{ mt: -2 }}>
          <AddCustomer
            formType={addCustomer.title === "Add Customer" ? "Add" : "Edit"}
            initialValues={form}
            closeModal={closeAddCustomerModal}
          />
        </DialogContent>
      </Dialog>
    </Box>
  );
}
